/**
 * Chuyển lỗi RTK Query / FetchBaseQuery thành chuỗi hiển thị (Snack/Alert).
 * FastAPI 422 trả `detail: [{loc, msg, ...}]` — chỉ lấy msg đầu tiên cho ngắn,
 * tránh dán nguyên JSON validation array vào snackbar.
 */
const MAX_MESSAGE_LEN = 200

/** Cắt phần SQL noise (statement + parameters) và clamp độ dài. */
function tidyMessage(raw: string): string {
  let s = (raw ?? '').trim()
  // psycopg2 / SQLAlchemy thường thêm "[SQL: ...] [parameters: ...]"
  s = s.replace(/\[SQL:[\s\S]*$/i, '').trim()
  s = s.replace(/\[parameters:[\s\S]*$/i, '').trim()
  // Loại các tiền tố loại "(psycopg2.errors.XXX)" để câu nhân văn hơn.
  s = s.replace(/^\([^)]*psycopg2[^)]*\)\s*/i, '')
  // Lấy dòng đầu — diag detail thường nằm dòng 1.
  const firstLine = s.split('\n', 1)[0].trim()
  s = firstLine || s
  if (s.length > MAX_MESSAGE_LEN) s = `${s.slice(0, MAX_MESSAGE_LEN - 1)}…`
  return s
}

export function futuresApiErrorMessage(error: unknown): string {
  let msg = 'An error occurred.'
  if (error && typeof error === 'object' && 'data' in error) {
    const data = (error as { data: unknown }).data
    if (typeof data === 'object' && data !== null && 'detail' in data) {
      const detail = (data as { detail: unknown }).detail
      if (Array.isArray(detail)) {
        const first = detail[0]
        if (first && typeof first === 'object' && 'msg' in first) {
          msg = String((first as { msg: unknown }).msg)
        } else {
          msg = detail.length > 0 ? String(detail[0]) : 'Validation error'
        }
      } else {
        msg = String(detail)
      }
    } else if (typeof data === 'string') {
      msg = data
    }
  } else if (error instanceof Error) {
    msg = error.message
  }
  return tidyMessage(msg)
}
